<template>
  <v-app id="amaze" v-bind:class="{ impersonating: $auth.impersonating() }">
    <div class="impersonationBanner hidden-sm-and-down">
      <p>
        You are viewing this page as
        <b v-html="$auth.user().display_name"></b> (<span
          v-html="$auth.user().organization.name"
        ></span
        >).
        <v-btn flat outline @click="stopImpersonateUser"
          >Stop Impersonating</v-btn
        >
      </p>
    </div>
    <v-navigation-drawer
      fixed
      temporary
      v-model="notificationDrawer"
      right
      clipped
      app
      mobile-break-point="0"
      disable-resize-watcher
      ref="notifDrawer"
      v-on:input="transition"
    >
      <v-list-tile
        avatar
        ripple
        active-class=""
        @click="notificationDrawer = false"
        class="notificationDrawerCloseWrapper"
      >
        <v-list-tile-action class="notificationDrawerClose">
          <v-icon color="primary">$vuetify.icons.amaze-close</v-icon>
        </v-list-tile-action>
        <!-- <v-list-tile-title>
          Close
        </v-list-tile-title> -->
      </v-list-tile>

      <AmazeNotifications></AmazeNotifications>
    </v-navigation-drawer>

    <v-toolbar id="mainToolbar" color="" fixed app clipped-right clipped-left>
      <v-toolbar-items>
        <v-btn
          flat
          @click.stop="navigationDrawer = !navigationDrawer"
          class="closeButton"
          :class="{ active: navigationDrawer }"
        >
          <v-icon x-large v-if="!navigationDrawer">menu</v-icon>
          <v-icon x-large primary v-if="navigationDrawer">close</v-icon>
        </v-btn>
      </v-toolbar-items>
      <v-toolbar-title>
        <h2 class="amaze-title">
          <router-link to="/dashboard">Amaze</router-link>
        </h2>
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-toolbar-items class="pr-3">
        <v-btn
          v-if="eventTracker"
          flat
          to="/dsec"
          class="hidden-sm-and-down icon-w-text"
        >
          <v-icon class="mr-2" small color="primary">fa fa-calendar</v-icon>
          DSEC Event Tracker
        </v-btn>
        <!-- <v-btn flat v-if="$auth.impersonating()" @click="stopImpersonateUser" class="hidden-sm-and-down">Stop Impersonating</v-btn> -->
        <v-btn flat to="/group/create" class="hidden-sm-and-down icon-w-text">
          <v-icon class="mr-1" color="primary">add</v-icon>
          Add a Group
        </v-btn>
        <v-btn flat to="/group/find" class="hidden-sm-and-down icon-w-text">
          <v-icon class="mr-1" color="primary"
            >$vuetify.icons.amaze-search</v-icon
          >
          Find a Group
        </v-btn>
        <v-btn
          flat
          max-width="20px"
          to="/feedback/create"
          class="narrow feedback icon-only"
        >
          <v-icon color="black" size="18px">far fa-question-circle</v-icon>
        </v-btn>
        <v-btn
          flat
          @click.stop="notificationDrawer = !notificationDrawer"
          class="narrow notifications icon-w-text"
        >
          <v-icon color="black" size="22px"
            >$vuetify.icons.amaze-notifications</v-icon
          >
          <div v-if="items > 0" class="notificationCount">
            <span v-html="items"></span>
          </div>
        </v-btn>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              flat
              to="/profile/edit"
              class="narrow avatar hidden-sm-and-down icon-only"
              v-bind="attrs"
              v-on="on"
            >
              <AmazeAvatar
                :user="user"
                :key="user.id"
                size="22px"
                hideTip="true"
              ></AmazeAvatar>
            </v-btn>
          </template>
          <span>{{ user.display_name }}</span>
        </v-tooltip>
      </v-toolbar-items>
    </v-toolbar>

    <v-navigation-drawer
      fixed
      v-model="navigationDrawer"
      app
      class="secondary mainNavigation"
      clipped
      mobile-break-point="960"
      disable-resize-watcher
      ref="navDrawer"
    >
      <v-list>
        <v-list-tile
          avatar
          ripple
          active-class=""
          @click="navigationDrawer = false"
          class="hidden-md-and-up"
          style="background-color: #ffffff"
        >
          <v-list-tile-action>
            <v-icon color="black" large>close</v-icon>
          </v-list-tile-action>
          <v-list-tile-title> Close </v-list-tile-title>
        </v-list-tile>
        <div v-if="$auth.check(['uber_admin', 'es_admin'])">
          <v-select
            v-model="currentOrg"
            hide-details
            :items="orgs"
            item-text="name"
            item-value="id"
            @change="changeOrg"
            label="Organization Toggle (Admin Only)"
            box
          ></v-select>
        </div>
        <v-list-tile
          to="/dashboard"
          @click="navigationDrawer = !navigationDrawer"
          active-class="secondary--text activeNav"
        >
          <v-list-tile-title>
            <v-icon>$vuetify.icons.amaze-dashboard</v-icon>
            <span>My Dashboard</span>
          </v-list-tile-title>
        </v-list-tile>

        <v-list-tile
          v-for="group in groups"
          :key="'group-' + group.id"
          :to="'/group/' + group.id"
          @click="navigationDrawer = !navigationDrawer"
          active-class="secondary--text activeNav"
        >
          <v-list-tile-title>
            <img
              :src="group.group_photo.large"
              :key="group.group_photo.large"
              v-if="group.group_photo.large"
            />
            <v-icon v-else>fa-comments</v-icon>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <div v-on="on">
                  <div class="truncate-text-content">{{ group.name }}</div>
                </div>
              </template>
              <span>{{ group.name }}</span>
            </v-tooltip>
          </v-list-tile-title>
        </v-list-tile>

        <v-list-tile
          v-for="lmodule in modules"
          :key="'module-' + lmodule.id"
          :to="'/module/' + lmodule.id"
          @click="navigationDrawer = !navigationDrawer"
          active-class="secondary--text activeNav"
        >
          <v-list-tile-title>
            <v-icon>fa-certificate</v-icon>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <div v-on="on">
                  <div class="truncate-text-content">{{ lmodule.name }}</div>
                </div>
              </template>
              <span>{{ lmodule.name }}</span>
            </v-tooltip>
          </v-list-tile-title>
        </v-list-tile>
      </v-list>

      <v-divider v-if="eventTracker"></v-divider>
      <v-list>
        <v-list-tile
          v-if="eventTracker"
          to="/dsec"
          @click="navigationDrawer = !navigationDrawer"
          active-class="secondary--text activeNav"
        >
          <v-list-tile-title
            ><v-icon>fa fa-calendar</v-icon> DSEC Event
            Tracker</v-list-tile-title
          >
        </v-list-tile>
      </v-list>
      <v-divider></v-divider>
      <v-list>
        <v-list-tile v-if="$auth.impersonating()" @click="stopImpersonateUser">
          <v-list-tile-title>Stop Impersonating</v-list-tile-title>
        </v-list-tile>
        <v-list-tile
          to="/logout"
          @click="navigationDrawer = !navigationDrawer"
          active-class="secondary--text activeNav"
        >
          <v-list-tile-title>Logout</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-content>
      <v-container
        fluid
        fill-height
        class="pa-0"
        :class="{ fullLoad: loading }"
      >
        <template>
          <keep-alive>
            <router-view></router-view>
          </keep-alive>
        </template>
      </v-container>
    </v-content>

    <amaze-snackbar></amaze-snackbar>

    <amaze-dialog
      :showDialog="showDialog"
      :returnRoute="returnRoute"
      ref="dialog"
    >
      <router-view name="dialogContent" @setReturnRoute="setReturnRoute" />
    </amaze-dialog>

    <v-footer height="auto">
      <v-card class="flex" flat tile>
        <v-card-title>
          <v-layout row wrap>
            <v-flex md7>
              <v-toolbar flat color="secondary" class="py-2">
                <h2 class="amaze-title">Amaze</h2>
                <v-divider vertical class="mr-4"></v-divider>
                <a
                  href="https://rti.org"
                  target="_blank"
                  style="display: block; width: 90px"
                >
                  <v-img
                    src="~@/assets/RTI_Logo_Black.svg"
                    class="mt-1"
                    max-width="90"
                    max-height="75"
                    aspect-ratio="2.5"
                    alt="RTI International"
                  />
                </a>
                <v-spacer class="hidden-sm-and-down"></v-spacer>
              </v-toolbar>
              <p>
                Amaze is a collaboration platform designed and developed by RTI
                International and is an initiative of
                <a href="https://educationservices.rti.org" target="_blank"
                  >RTI's Center for Education Services
                  <v-icon size="10" style="vertical-align: middle"
                    >fas fa-external-link-alt</v-icon
                  ></a
                >. &copy;{{ new Date().getFullYear() }} RTI International. RTI
                International is a trade name of Research Triangle Institute.
                RTI and the RTI logo are U.S. registered trademarks of Research
                Triangle Institute.
                <a href="https://www.rti.org/privacy-policy" target="_blank"
                  >Privacy Policy
                  <v-icon size="10" style="vertical-align: middle"
                    >fas fa-external-link-alt</v-icon
                  ></a
                >
                |
                <a href="https://www.rti.org/terms-use" target="_blank"
                  >Terms of Use
                  <v-icon size="10" style="vertical-align: middle"
                    >fas fa-external-link-alt</v-icon
                  ></a
                >
              </p>
              <AmazeDevelopmentInfo/>
            </v-flex>
            <v-flex md5>
              <br />
              <p class="text-md-right">
                <span class="contactus py-2 px-3"
                  >Contact us at
                  <a :href="'mailto: ' + contactAddress">{{ contactAddress }}</a
                  >.</span
                >
              </p>
            </v-flex>
          </v-layout>
        </v-card-title>
      </v-card>
    </v-footer>
    <cookie-law theme="royal">
      <div slot-scope="props">
        <p class="py-0 my-0 pr-2" style="display: inline-block; width: 90%">
          RTI uses cookies to offer you the best experience online. By
          continuing to use our website, you agree to the use of cookies. If you
          would like to know more about cookies and how to manage them please
          view our
          <a
            href="https://www.rti.org/privacy-policy"
            target="_blank"
            color="black"
            >Privacy Policy</a
          >.
        </p>
        <v-btn
          class="px-0 py-0 ma-0 mt-2"
          style="display: inline-block; vertical-align: top"
          @click="props.accept"
          >I accept</v-btn
        >
      </div>
    </cookie-law>
  </v-app>
</template>

<style lang="scss">
@import "src/styles/variables.scss";

.contactus {
  background-color: white;
}
.notificationCount {
  display: inline-block;
  text-align: center;
  font-family: $amaze-text-font-stack;
  font-size: 8px;
  background-color: $icon-img;
  border-radius: 50%;
  color: white;
  padding: 2px;
  border: 1px solid white;
  margin-left: -10px;
  margin-top: -20px;
  min-width: 8px;
  min-height: 8px;
  line-height: 1;
  box-sizing: content-box;
  white-space: nowrap;
  &:before {
    content: "";
    display: inline-block;
    vertical-align: middle;
    padding-top: 100%;
    height: 0;
  }
  span {
    display: inline-block;
    vertical-align: middle;
  }
}
.v-toolbar__items {
  .narrow {
    // margin: 0 -15px !important;
    max-width: 50px;
    min-width: 50px;
    flex: none;
  }
}
.amaze-title a {
  color: #000 !important;
}
.fullLoad {
  filter: blur(12px);
  pointer-events: none;
}
.v-toolbar--fixed {
  z-index: 20 !important;
}
.v-toolbar__content {
  padding-left: 0;
  padding-right: 0;
}

.icon-w-text.v-btn {
  text-transform: inherit;
}

.icon-only.v-btn.v-btn--floating {
  height: 30px;
  width: 30px;
  margin-left: 3px;
  margin-right: 3px;
}

.closeButton {
  background-color: $amaze-yellow;
  border-radius: 0;
  width: 20px;
  min-width: 68px;
}
.contactus {
  background-color: #ffffff;
}
// .v-navigation-drawer > .v-list {
//   list-style-type: none;
//   padding-top: 0;
//   .v-list__tile {
//     color: $font-color !important;
//     &.activeNav {
//       color: #fff !important;
//       background-color: #8f7220;
//       position: relative;
//       &:before {
//         content: "\f054"; /* this is your text. You can also use UTF-8 character codes as I do here */
//         font-family: "Font Awesome\ 5 Free";
//         right: 10px;
//         position: absolute;
//         top: 18%;
//         font-size: 22px;
//       }
//     }
//   }
// }

.v-navigation-drawer {
  .notificationDrawerCloseWrapper {
    margin-bottom: -30px;
    margin-top: $amaze-header-height;
    max-height: calc(100% - #{$amaze-header-height});
    .notificationDrawerClose {
      background: transparent !important;
      display: block;
      width: 100%;
      text-align: right;
      padding: 0;
      margin: 0;
      margin-top: 15px;
      margin-bottom: -15px;
    }
  }

  > .v-list {
    list-style-type: none;
    padding-top: 0;
    .v-list__tile {
      color: $font-color !important;
      &.activeNav {
        color: #fff !important;
        background-color: $amaze-yellow-dark;
        position: relative;
      }
    }
    [role="listitem"]:not(:last-of-type) {
      margin-bottom: 10px;
    }
    .v-list__tile__title {
      display: flex;
      align-items: center;
      font-size: 16px;
      font-weight: bold;
      font-family: $amaze-text-font-stack;
      height: auto;
      white-space: normal;
      overflow: visible;
      text-overflow: initial;
      vertical-align: middle;
      img {
        vertical-align: middle;
        margin-right: 10px;
        font-size: 28px;
        float: left;
        font-size: 28px;
        width: 28px;
        height: 28px;
        border-radius: 50%;
        border: 1px solid $amaze-yellow-dark;
      }
      .v-icon {
        color: black;
        vertical-align: middle;
        margin-right: 10px;
        font-size: 28px;
        float: left;
        font-size: 28px;
        width: 28px;
        height: 100%;
      }
    }
    .v-list__tile--active {
      .v-list__tile__title {
        .v-icon {
          color: white;
        }
      }
    }
  }
}

nav#mainToolbar {
  min-height: $amaze-header-height;
  .v-toolbar__content {
    min-height: $amaze-header-height !important;
    height: $amaze-header-height !important;
  }
}

.mainNavigation .v-list .v-list__tile {
  font-weight: 600;
}
p {
  padding-top: 11px;
}
.v-footer {
  background-color: $amaze-yellow;
  h2 {
    padding-right: 25px;
  }
  p {
    padding-top: 11px;
  }
  a {
    color: $font-color !important;
    text-decoration: underline;
    &.feedback {
      text-decoration: none;
    }
  }
  .v-card {
    background-color: $amaze-yellow !important;
    font-size: 0.8em;
  }
}

.impersonating {
  .impersonationBanner {
    position: fixed;
    top: 0;
    z-index: 9999;
    background-color: $amaze-dark-background;
    color: $white;
    width: 100%;
    height: $amaze-header-height !important;
    max-height: $amaze-header-height;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    vertical-align: middle;
    margin-left: auto;
    margin-right: auto;
    * {
      font-family: $amaze-text-font-stack;
      color: $white;
      font-size: 14px;
    }
  }
}

.impersonationBanner {
  height: $amaze-header-height !important;
  max-height: $amaze-header-height;
}

@media (min-width: 960px) {
  main.v-content {
    padding-top: 0px !important;
  }
  .impersonating {
    aside.mainNavigation {
      margin-top: 128px !important;
    }
    main.v-content {
      margin-top: 128px !important;
    }
    #mainToolbar {
      margin-top: $amaze-header-height !important;
    }
    .v-navigation-drawer {
      margin-top: 128px;
      .notificationDrawerCloseWrapper {
        margin-bottom: -30px;
        margin-top: 128px;
        max-height: calc(100% - 128px);
      }
    }
  }
}
</style>

<script>
import CookieLaw from "vue-cookie-law";
import AmazeDialog from "@/components/Widgets/AmazeDialog";
import AmazeNotifications from "@/components/Widgets/AmazeNotifications";
import MemberService from "@/services/MemberService";
import AmazeAvatar from "@/components/Widgets/AmazeAvatar";
import permissionsMixin from "@/mixins/permissionsMixin.js";
import AmazeDevelopmentInfo from "@/components/Widgets/AmazeDevelopmentInfo";
export default {
  components: {
    AmazeDialog,
    AmazeNotifications,
    CookieLaw,
    AmazeAvatar,
    AmazeDevelopmentInfo
  },
  mixins: [permissionsMixin],
  data() {
    return {
      showDialog: this.$route.meta.showDialog,
      navigationDrawer: false,
      notificationDrawer: false,
      isImpersonating: false,
      orgs: null,
      currentOrg: this.$auth.user().organization_id,
      returnRoute: false
    };
  },
  computed: {
    items() {
      return this.$store.state.notifications
        ? this.$store.state.notifications.length < 21
          ? this.$store.state.notifications.length
          : "20+"
        : false;
    },
    user() {
      return this.$auth.user();
    },
    groups() {
      return this.$store.state.groups;
    },
    modules() {
      return this.$store.state.modules;
    },
    hasModules() {
      return this.$store.state.modules
        ? this.$store.state.modules.length > 0
        : false;
    },
    loading() {
      return this.$store.state.loading;
    },
    contactAddress() {
      return process.env.VUE_APP_CONTACT_ADDRESS;
    },
    eventTracker() {
      return this.amazeUserCan("view", "dsec_calendar");
    }
  },
  methods: {
    setReturnRoute(routeInfo) {
      this.returnRoute = routeInfo;
    },
    transition(event) {
      /*
       * 2020-09-15: We don't want double scrollbars (i.e. notifications and main html).
       * The navigation drawer behaves inconsistently in this respect, with all
       * the options/props/etc I reviewed. This applies the overflow-y-hidden
       * class to the main html element at any screen width. Normally this happens
       * automatically at smaller screen widths, but doesn't at larger widths.
       */
      if (event) {
        document.documentElement.classList.add("overflow-y-hidden");
      } else {
        document.documentElement.classList.remove("overflow-y-hidden");
      }
    },
    isThisImpersonating() {
      this.isImpersonating = this.$auth.impersonating();
    },
    stopImpersonateUser() {
      MemberService.stopImpersonateUser(this.$auth.user().id).then(
        (response) => {
          this.$store.commit("updateNotifications");
          this.$store.commit("updateGroups");
          this.$store.commit("updateModules");
          this.fetchOrganizations();
        },
        (response) => {
          console.error("[error] stopImpersonateUser");
        }
      );
    },
    documentClick(e) {
      // 2021-11-11: I don't recall why we return false here now.
      return false;

      // 2021-11-11: I'm cleaning up linting issues and below is unreachable.

      // close drawer if the document catches a click outside the drawer(s) element
      /* let navDrawer = this.$refs.navDrawer;
      let notifDrawer = this.$refs.notifDrawer;
      let target = e.target;
      if (navDrawer.$el !== target && !navDrawer.$el.contains(target)) {
        this.navigationDrawer = false;
      }
      if (notifDrawer.$el !== target && !notifDrawer.$el.contains(target)) {
        this.notificationDrawer = false;
      } */
    },
    changeOrg() {
      if (this.$auth.check(["uber_admin", "es_admin"])) {
        this.$http
          .put("users/" + this.$auth.user().id, {
            organization_id: this.currentOrg
          })
          .then(
            (response) => {},
            (response) => {
              console.log("Error changing organizations.");
            }
          );
      }
    },
    fetchOrganizations() {
      if (this.$auth.check(["uber_admin", "es_admin"])) {
        this.$http.get("organizations/list").then(
          (response) => {
            this.orgs = response.body.data;
          },
          (response) => {
            console.log("Error getting organizations.");
          }
        );
      }
    }
  },
  watch: {
    "$route.meta"({ showDialog }) {
      this.showDialog = showDialog;
    },
    $route(to, from) {
      this.$auth.fetch();
    }
  },
  created() {
    this.$store.commit("updateGroups");
    this.$store.commit("updateModules");
    this.isThisImpersonating();
    // Custom dimensions for google analytics
    this.$ga.set({ dimension1: this.$auth.user().id.toString() });
    this.$ga.set({ dimension2: this.$auth.user().states.name });
    this.$ga.set({ dimension3: this.$auth.user().roles.join(", ") });
    this.$ga.set({ dimension4: this.$auth.user().organization.name });
    document.addEventListener("click", this.documentClick);
    this.fetchOrganizations();
  },
  destroyed() {
    document.removeEventListener("click", this.documentClick);
  }
};
</script>
